import * as React from "react";

export const IconPlus = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9.99902 3.83301C10.4593 3.83301 10.832 4.20676 10.832 4.66699V9.66699L15.832 9.66699C16.2923 9.66699 16.666 10.0398 16.666 10.5C16.666 10.9602 16.2923 11.333 15.832 11.333L10.832 11.333L10.832 16.333C10.832 16.7932 10.4593 17.167 9.99902 17.167C9.53879 17.167 9.16602 16.7932 9.16602 16.333L9.16602 11.333H4.16602C3.70578 11.333 3.33203 10.9602 3.33203 10.5C3.33203 10.0398 3.70578 9.66699 4.16602 9.66699H9.16602V4.66699C9.16602 4.20676 9.53879 3.83301 9.99902 3.83301Z"
      fill="currentColor"
    />
  </svg>
);
